import { createSlice } from "@reduxjs/toolkit";
import { getSignatureProviders } from "./actions/getSignatureProviders";

interface SignatureProvidersState {
    providers: {
        createdAt: string,
        updatedAt: string,
        id: number,
        code: number,
        name: string,
    }[];
    getSignatureProvidersStatus: "idle" | "pending" | "succeeded" | "failed";
}

const initialState = {
    providers: [],
    getSignatureProvidersStatus: "idle",
} as SignatureProvidersState;

const signatureProvidersSlice = createSlice({
    name: "signatureProviders",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSignatureProviders.pending, (state) => {
                state.getSignatureProvidersStatus = "pending";
                state.providers = [];
            })
            .addCase(getSignatureProviders.fulfilled, (state, { payload }) => {
                state.getSignatureProvidersStatus = "succeeded";
                state.providers = payload;
            })
            .addCase(getSignatureProviders.rejected, (state) => {
                state.getSignatureProvidersStatus = "failed";
                state.providers = [];
            });
    },
});

export default signatureProvidersSlice.reducer;
